<template>
    <div class="TodoIndex row justify-content-center">
        <div class="card col-sm-6" v-for="task in tasks" :key="task.id">
            <div class="card-content">
                <i class="delete material-icons" @click="deleteTask(task.id)">delete</i>
                <h2 class="indigo-text">{{task.title}}</h2>
                <ul class="subTasks">
                    <li v-for="(subTask,index) in task.subTasks" :key="index">
                        <span class="chip">{{subTask}}</span>
                    </li>
                </ul>
            </div>
            <span class="btn-floating btn-large halfway-fab pink">
                <router-link :to="{name : 'EditTask', params:{task_slug: task.slug}}">
                    <i class="material-icons edit">edit</i>
                </router-link>
            </span>
        </div>
    </div>
</template>

<script>
import db from '@/firebase/init'
export default {
    name: 'TodoIndex',
    data() {
        return{
            tasks:[]
        }
    },
    methods:{
        deleteTask(id){
            //delete from firestore
            db.collection("Todo-List").doc(id).delete().then(() => {
                this.tasks=this.tasks.filter(task => {
                    return task.id != id
                })
            })
        }
    },
    created(){
        //fetch data from firestore
        db.collection("Todo-List").get().then(snapshot => {
            snapshot.forEach(element => {
                let task = element.data();
                task.id = element.id;
                this.tasks.push(task)
            });
        })
    }
    
}
</script>

<style scoped>
.TodoIndex{
    margin-top: 60px;
}
.TodoIndex .card{
    margin: 20px 20px;
    width:250px;
    min-height: 250px;
}

h2{
    font-size: 1.8em;
    text-align: center;
    margin-top: 0px;
}
.subTasks{
    margin:30px auto;
}

.subTasks li{
    display: inline-block;
}

.delete{
    position: absolute;
    top: 7px;
    right:7px;
    cursor: pointer;
    color: #aaa;
    font-size: 1.4em;
}

</style>